"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
exports.default = {
    show: prop_types_1.default.bool.isRequired,
    title: prop_types_1.default.node,
    subtitle: prop_types_1.default.node,
    iconNavigation: prop_types_1.default.node,
    showCloseButton: prop_types_1.default.bool,
    onClose: prop_types_1.default.func,
    bsSize: prop_types_1.default.oneOf(['sm', 'md', 'lg', 'xl', 'full', 'fullscreen']),
    disableEsc: prop_types_1.default.bool,
    useOverflow: prop_types_1.default.bool,
    className: prop_types_1.default.string,
};
